import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AgentForm from './AgentForm';
import { Agent } from '../../types/agent';
import AgentHelpModal from './AgentHelpModal';
import { useTranslation } from 'react-i18next';

type AgentFormDialogProps = {
  open: boolean;
  agentId?: string;
  onClose: () => void;
  onSaved: (agent: Agent) => void;
  initialData?: Partial<Agent>;
};

const AgentFormDialog: React.FC<AgentFormDialogProps> = ({ open, agentId, onClose, onSaved, initialData }) => {
  const { t } = useTranslation();
  const isEditing = Boolean(agentId);
  const [helpOpen, setHelpOpen] = useState(false);

  return (
    <Dialog 
      open={open} 
      onClose={() => { }} 
      maxWidth="lg" 
      fullWidth 
      disableEscapeKeyDown
      fullScreen={window.innerWidth < 768}
      sx={{
        '& .MuiDialog-paper': {
          height: window.innerWidth < 768 ? '100vh' : 'auto',
          margin: window.innerWidth < 768 ? 0 : 'auto',
          maxHeight: window.innerWidth < 768 ? '100vh' : '90vh',
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        gap: 1,
        py: window.innerWidth < 768 ? 1.5 : 2
      }}>
        {isEditing ? t('agents.edit') : t('agents.create')}
        <Box>
          <IconButton aria-label="close" onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent 
        dividers 
        sx={{ 
          flex: 1,
          overflow: window.innerWidth < 768 ? 'hidden' : 'auto',
          display: 'flex',
          flexDirection: 'column',
          p: window.innerWidth < 768 ? 1 : 2
        }}
      >
        <AgentForm
          agentId={agentId}
          initialData={initialData}
          onSave={(agent: Agent) => {
            onSaved(agent);
            onClose();
          }}
          onCancel={onClose}
        />
      </DialogContent>
      <AgentHelpModal open={helpOpen} onClose={() => setHelpOpen(false)} topic="basic-info" />
    </Dialog>
  );
};

export default AgentFormDialog;


